/**
 * @file gtpAPI.js
 * @description API calls for Go To Points and Feature Analytics (public)
 */
import { API } from "../lib/Request";
import AppConfig from "../config";

const accountUrl = AppConfig.ACCOUNT_URL;

export const GetGtpById = async (id) => {
  return new Promise((resolve, reject) => {
    API({
      url: `${accountUrl}/admin/go-to-points/${id}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const GetPostalCodes = async (search) => {
  return new Promise((resolve, reject) => {
    API({
      url: `${accountUrl}/admin/go-to-points/postal-codes?search=${search}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const PostFeatureAnalytic = async (payload) => {
  return API({
    url: `${accountUrl}/public/feature-analytic`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: payload,
  });
};
